import React from 'react';
import PropTypes from 'prop-types';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import { useTranslation } from 'react-i18next/src';
import { capitalize } from '@mui/material';
import TextCopy from '../../../../../../components/forms/DNSAuthenticationFrom/components/TextCopy';
import { StyledBadge, StyledText } from '../../../../../../components/atoms/Typography/StyledText';

const COLUMNS = ['type', 'name', 'value', 'status'];
const CELLS = {
  type: StyledText,
  name: TextCopy,
  value: TextCopy,
  status: StyledBadge,
};

const Resources = ({ rows, status, variant }) => {
  const { t } = useTranslation();

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            {COLUMNS.map((column) => (
              <TableCell key={column}>{capitalize(t(column))}</TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {rows?.map((rowData) => (
            <TableRow key={`${rowData.type}-${rowData.name}-${rowData.value}`} hover>
              {COLUMNS.map((column) => {
                const Cell = CELLS[column] ?? CELLS.type;
                const data = rowData[column] || status;

                return (
                  <TableCell key={column}>
                    <Cell {...(column === 'status' && { variant })} name={column}>
                      {data}
                    </Cell>
                  </TableCell>
                );
              })}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

Resources.propTypes = {
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ),
  status: PropTypes.string,
  variant: PropTypes.string,
};

Resources.defaultProps = {
  rows: null,
  status: '',
  variant: '',
};

export default Resources;
